import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from '../../../redux/title/action';
import { StyledContainer } from '../../../components/container/styles';
import { useGetCustomer } from './hooks/useGetCustomer';
import { setInfo } from '../../../redux/info/action';
import { setCookies } from '../../../store/useCookies';
import { useHistory } from 'react-router-dom';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { useFormState } from './hooks/useFormState';
import { useRegisterTel } from './hooks/useRegisterTel';
import { RequestOtpForm } from './views/request-otp-form/RequestOtpForm';
import { useModal } from '../../../components/modal/hooks/useModal';
import { getPolicyPDPAQuery } from './hooks/policies';
import { Skeleton } from 'antd';
import { PolicyModal } from './views/policy-modal/PolicyModal';
import { openAlert } from '../../../components/alert/hooks';
import { ConfirmOtpForm } from './views/confirm-otp-form/ConfirmOtpForm';
import { TimerForm } from './views/timer-form/TimerForm';
import ErrorScene from '../../error';

export const RegisterTelScene = () => {
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.line.profile);
  const history = useHistory();
  const { open, onToggle } = useModal();
  const { submitOtpDefaultValues } = useFormState();
  const { data: pdpaResult, isLoading, error } = getPolicyPDPAQuery();
  const [isComfirmOtp, setConfirmOtp] = useState(false);
  const [otpRequest, setOtpRequest] = useState(submitOtpDefaultValues);
  const { mutate: onCallInfo } = useGetCustomer();
  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนเบอร์โทรศัพท์'));
  }, [dispatch]);

  const { registerPost } = useRegisterTel({
    onRequestOtpSuccessCallBack: (response) => {
      setOtpRequest((prev) => ({
        ...prev,
        ...response,
      }));
      setConfirmOtp(true);
    },
    onConfirmOtpSuccessCallBack: (response) => {
      setOtpRequest((prev) => ({
        ...prev,
        ...response,
      }));
      fetchCustomerInfo();
    },
  });

  useEffect(() => {
    onToggle(true);
  }, []);

  function handlePdpaSummit(value) {
    setOtpRequest((prev) => ({
      ...prev,
      isPolicyAccept: value,
    }));
    onToggle(false);
  }

  if (isLoading) {
    return <Skeleton active />;
  }

  if (error) {
    openAlert({
      type: 'error',
      message: error.error || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
    });
    return <ErrorScene />;
  }

  function handleSubmitOTP(values) {
    const data = {
      otpCode: values?.otp,
      otpRef: otpRequest?.otpRef,
      telephone: otpRequest?.telephone,
      isPolicyAccept: otpRequest && otpRequest.isPolicyAccept ? otpRequest.isPolicyAccept : false,
      lineUid: userProfile?.userId,
      lineName: userProfile?.displayName,
    };
    registerPost(data, 'CONFIRM');
    setConfirmOtp(true);
    setOtpRequest((prev) => ({
      ...prev,
      ...values,
    }));
  }

  function fetchCustomerInfo() {
    if (userProfile?.userId) {
      onCallInfo(
        { userId: userProfile.userId },
        {
          onSuccess: (info) => {
            dispatch(setInfo(info?.result?.item));
            setCookies('accessToken', info?.result.item.accessToken);
            history.push(ROUTES_PATH.ROUTE_HOME.PATH);
          },
          onError: (err) => {
            openAlert({
              type: 'error',
              message: err?.message,
            });
          },
        },
      );
    }
  }

  function handleSubmitTelephone(values) {
    registerPost(values, 'REQUEST');
  }

  function handleResendOtp() {
    setConfirmOtp(false);
  }

  return (
    <StyledContainer style={{ width: '100%' }}>
      {open && (
        <PolicyModal
          open={open}
          onToggle={onToggle}
          policyText={pdpaResult}
          handleSubmitSuccess={handlePdpaSummit}
        />
      )}
      <RequestOtpForm disabledBtn={isComfirmOtp} handleSubmitSuccess={handleSubmitTelephone} />
      {isComfirmOtp && <TimerForm handleResend={handleResendOtp} />}
      {isComfirmOtp && (
        <ConfirmOtpForm
          handleSubmitSuccess={handleSubmitOTP}
          otpRef={otpRequest ? otpRequest.otpRef : ''}
        />
      )}
    </StyledContainer>
  );
};
